import { isNil } from 'lodash-es';
import { isSafari } from 'helpers/is';

const Input = ({
  onChange,
  onBlur,
  Component,
  staticClass,
  className,
  innerRef,
  ...rest
}) => {
  const handleChange = (evt) => {
    const value = evt.target ? evt.target.value : evt;

    onChange
      && onChange({
        key: rest.name,
        value,
      });
  };

  const handleBlur = (e) => {
    scrollFieldToStart(e.target);
    onBlur && onBlur();
  };

  const scrollFieldToStart = (node) => {
    if (isSafari || isNil(node) || node?.selectionStart <= 0) return;

    setTimeout(() => {
      node.setSelectionRange(0, 0, 'forward');
      node.scrollLeft = 0;
    }, 0);
  };

  return (
    <Component
      className={cx(staticClass, className)}
      onChange={handleChange}
      onBlur={handleBlur}
      ref={innerRef}
      {...rest}
    />
  );
};

Input.defaultProps = {
  staticClass: 'input',
  className: '',
  type: 'text',
  autoComplete: 'off',
  spellCheck: 'false',
  Component: 'input',
};

export default Input;
